import React from 'react'
import cx from 'classnames'
import CheckFillIcon from 'remixicon-react/CheckFillIcon'
import { history } from '@components/App'
import styles from './index.scss'

type StepsType = {
    title: string
    route: string
}

interface IStepper {
    steps?: StepsType[]
    current?: string | number
    absoluteStyleContainer?: boolean
}

function Stepper(props: IStepper) {
    const { steps = [], current = undefined, absoluteStyleContainer = false } = props
    const currentIndex = current || 0

    return (
        <div className={cx(styles['stepper'], { [styles['absolute-container']]: absoluteStyleContainer })}>
            {steps.map((item: StepsType, index: number) => (
                <div
                    key={index}
                    className={cx(styles['stepper__step'], {
                        [styles['checked']]: index < Number(currentIndex),
                        [styles['current']]: index == currentIndex
                    })}
                    onClick={() => {
                        if (index < Number(currentIndex)) {
                            history.push({
                                pathname: item.route,
                                search: location.search
                            })
                        }
                    }}
                >
                    <span
                        className={cx(styles['stepper__step_circle'], {
                            [styles['stepper__step_line']]: index !== steps.length - 1
                        })}
                    >
                        {index < Number(currentIndex) ? <CheckFillIcon /> : index + 1}
                    </span>
                    <span className={styles['stepper__step_label']}>{item?.title}</span>
                </div>
            ))}
        </div>
    )
}

export default Stepper
